import { render } from "./SaleEmployeeDetail.vue?vue&type=template&id=9b4e3078&scoped=true"
import script from "./SaleEmployeeDetail.vue?vue&type=script&lang=js"
export * from "./SaleEmployeeDetail.vue?vue&type=script&lang=js"

import "./SaleEmployeeDetail.vue?vue&type=style&index=0&id=9b4e3078&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9b4e3078"]])

export default __exports__